const DATA_TYPES = [
    {
        text: 'Boolean',
        value: 'boolean',
    },
    {
        text: 'Date',
        value: 'date',
    },
    {
        text: 'Decimal',
        value: 'float',
    },
    {
        text: 'JSON',
        value: 'json',
    },
    {
        text: 'Integer',
        value: 'integer',
    },
    {
        text: 'Text',
        value: 'text',
    },
    {
        text: 'Foreign key',
        value: 'text',
    },
    {
        text: 'Timestamp',
        value: 'timestamp',
    },
    {
        text: 'UUID',
        value: 'uuid',
    },
    {
        text: 'Table (reference)',
        value: 'foreign_key',
    },
    {
        text: 'Bigint',
        value: 'bigint',
    },
]
const WEEK_DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
// eslint-disable-next-line no-undef
const MONTH_DAYS = _.concat(Array.from({ length: 28 }, (v, k) => (k + 1) <= 9 ? ('0' + (k + 1)) : (k + 1)), ['-02', '-01', '00'])
export {
    DATA_TYPES,
    WEEK_DAYS,
    MONTH_DAYS,
}
